import React from "react"
import SettingsCard from "../../common/SettingsCard"
import ScheduledJobsCard from "../../../pages/account/AccountSettings/scheduled_job/ScheduledJobsCard"
import AgreementSet from "../../../components/agreement/settting/AgreementSet"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
import AccountStore from "../../../stores/AccountStore"

interface IProps {
    accountManagerId: string
}

interface IState {
    expanded: string
    loadingAgreement: boolean
    requireAgreement: boolean
}

export default class AccountManagerDetailsSystemTab extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            expanded: "",
            loadingAgreement: true,
            requireAgreement: false,
        }

    }

    componentDidMount(): void {
        this.getFinddPolicyRequired()
    }

    onExpandClick(type) {
        this.setState({ expanded: this.state.expanded === type ? "" : type })
    }

    getFinddPolicyRequired() {
        api.getLatestPrivacy().then(res =>
            this.setState({
                loadingAgreement: false,
                requireAgreement: res.data ? true : false
            })
        )
    }

    render() {
        return (
            <div style={{ padding: 30 }}>
                <SettingsCard expanded={"scheduledJobs" === this.state.expanded} cardLabel={checkJobFieldAvailable('plural')? `Scheduled ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}`: strings.ScheduledJobs} handleExpandChange={() => this.onExpandClick("scheduledJobs")}>
                    <ScheduledJobsCard isAccountManager accountManagerId={this.props.accountManagerId} />
                </SettingsCard>
                <SettingsCard expanded={"privacyPolicy" === this.state.expanded} cardLabel={"Privacy Policy"} handleExpandChange={() => this.onExpandClick("privacyPolicy")}>
                    {!this.state.loadingAgreement &&
                        <AgreementSet
                            finddAgreement
                            cannotDisable
                            requireAgreement={this.state.requireAgreement}
                        />
                    }
                </SettingsCard>
            </div>
        )
    }
}
